/** The usage metrics channels, also the `{channel}` path segment of the billing API. */
export const BILLING_TYPE = {
  MESSAGE: 'MESSAGE',
  CLIPPING: 'CLIPPING',
  DOCUMENTS: 'DOCUMENTS',
  PHONE_AGENT: 'PHONE_AGENT',
} as const;

export type BillingTypeEnum = (typeof BILLING_TYPE)[keyof typeof BILLING_TYPE];

export const DOCUMENT_VALIDATION_TYPE = {
  DOCUMENT_ONLY: 'AUTOMATED_DOCUMENT_VALIDATION_DOCUMENT_ONLY',
  DOCUMENT_AND_IDENTITY: 'AUTOMATED_DOCUMENT_VALIDATION_DOCUMENT_AND_IDENTITY',
} as const;

export type DocumentValidationTypeEnum = (typeof DOCUMENT_VALIDATION_TYPE)[keyof typeof DOCUMENT_VALIDATION_TYPE];

/** The two document variants are queried apart but exported under a single channel. */
export const DOCUMENTS_EXPORT_ENTITY = 'AUTOMATED_DOCUMENT_VALIDATION';

export const BILLING_PERIOD = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const;

export type BillingPeriodEnum = (typeof BILLING_PERIOD)[keyof typeof BILLING_PERIOD];

/** The aggregation level a query reads, and the last segment of the billing API path. */
export const BILLING_SCOPE = {
  DEALERS: 'dealers',
  GROUPS: 'groups',
} as const;

export type BillingScopeEnum = (typeof BILLING_SCOPE)[keyof typeof BILLING_SCOPE];

/** The period granularity the API answers on: one row per month. */
export const BILLING_PERIOD_FORMAT = 'yyyy-MM';

/** What a dashboard sorts by until the user clicks a column header. */
export const DEFAULT_SORT = 'name,asc';

/**
 * The entity a slice is keyed by: a channel, or one of the two document variants — the documents
 * screen fetches each variant separately, so both get their own slice.
 */
export type BillingEntityEnum = BillingTypeEnum | DocumentValidationTypeEnum;
